import { useWidgetRuntime } from "@/features/shared/widget-context/widget-runtime-context";

/**
 * Time range / selected location are resolved from the nearest
 * {@link WidgetRuntimeProvider} (the dashboard page or the CMS widget host).
 * These hooks keep their historical names/shapes so existing call sites work
 * unchanged; the state itself is now page-scoped React context rather than a
 * module-global singleton. Outside a provider they return the non-throwing
 * default runtime (a default TimeRange, no location, no-op setters).
 */

export const useSelectedLocationId = () => useWidgetRuntime().selectedLocationId;

export const useSelectedTimeRange = () => useWidgetRuntime().timeRange;

export const useDashboardStoreActions = useWidgetRuntime;
